<template>
  <div>
    <HeroSection />
    <AboutSection />
    <SpeakersSection />
    <Cta1Section />
    <ExplainerVideos />
    <!-- <TestimonialsSection /> -->
    <Cta2Section />
    <FooterSection />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";

export default {
  name: "Home",
  title: "Home",

  components: {
    HeroSection: () => import("@/components/landing/HeroSection"),
    AboutSection: () => import("@/components/landing/AboutSection"),
    SpeakersSection: () => import("@/components/landing/SpeakersSection"),
    Cta1Section: () => import("@/components/landing/Cta1Section"),
    ExplainerVideos: () => import("@/components/landing/ExplainerVideos"),
    Cta2Section: () => import("@/components/landing/Cta2Section"),
    // TestimonialsSection: () =>
    //   import("@/components/landing/TestimonialsSection"),
    FooterSection: () => import("@/components/landing/FooterSection"),
  },
  data() {
    return {};
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
    }),
  },
  mounted() {
    console.log(process.env.VUE_APP_PROJECT_ID);
  },
};
</script>
